import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";

export const _fetchDownloads = (data) => {
  const request = {
    endPoint: serviceRouteConstants.downloads,
    data: data,
  };
  return post(request);
};
